import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Professional",
  icon: "💼",
  templates: [
    {
      title: "YouTube / Video Script",
      content: `Write a script for a YouTube video meant to be narrated by a single speaker.
- The video topic is [5 common mistakes people make when working from home — and how to fix them].
- Target audience: [young professionals starting their first remote job].
- Tone: [friendly, conversational, and practical — like advice from a trusted colleague].
- Structure with a strong hook in the first two sentences, clear transitions between points, and a brief closing with a call to action.
- Write for spoken delivery: use contractions, short paragraphs, and rhetorical questions to keep the listener's attention.`
    },
    {
      title: "Product Explainer",
      content: `Write a voiceover script for a product explainer video.
- The product is [a mobile app that helps small business owners track expenses by scanning receipts].
- Target audience: [freelancers and small business owners who hate bookkeeping].
- Key benefits to highlight:
  1. [Scan a receipt in 2 seconds — no manual entry].
  2. [Automatic expense categories with smart suggestions].
  3. [One-tap export for tax season].
- Tone: [clear, upbeat, and reassuring — this makes a painful task easy].
- Keep sentences concise and punchy. Avoid jargon.`
    },
    {
      title: "Presentation Speech",
      content: `Write a speech for a professional presentation or keynote.
- The occasion is [a company all-hands meeting to kick off a new quarter].
- The speaker is [a team lead addressing a mixed audience of engineers, designers, and managers].
- Core message: [celebrating last quarter's wins, acknowledging challenges honestly, and rallying the team around a clear focus for the months ahead].
- Tone: [confident, genuine, and motivating — not corporate-speak].
- Approximate spoken length: [4 minutes].
- Use conversational phrasing, strategic pauses, and a memorable closing line.`
    }
  ]
};
